import { render, staticRenderFns } from "./SiteNotice.vue?vue&type=template&id=39bcf06c&"
import script from "./SiteNotice.vue?vue&type=script&lang=js&"
export * from "./SiteNotice.vue?vue&type=script&lang=js&"
import style0 from "./SiteNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports